import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';

import { useBulkTypeOptionsStyles } from './BulkTypeOptions.styles';

/**
 * @typedef {Object} BulkOption
 * @property {string} name
 * @property {string} label
 * @property {number} position
 */

/**
 * Renders a group of sorted checkbox options.
 *
 * This component takes a list of options, sorts them by their `position` property,
 * and renders them as a FormGroup of Checkboxes.
 *
 * @param {Object} props
 * @param {(name: string, checked: boolean) => void} [props.onCheckOption]
 * @param {BulkOption[]} [props.options]
 * @param {Object.<string, boolean>} props.watchers
 * @returns {JSX.Element}
 */
export const BulkTypeOptions = ({ onCheckOption, options, watchers }) => {
  const classes = useBulkTypeOptionsStyles();
  const orderedOptions =
    options && options.length > 0 ? [...options].sort((a, b) => a.position - b.position) : [];

  return (
    <FormGroup row className={classes.container}>
      {orderedOptions.map(({ name, label }) => (
        <FormControlLabel
          key={name}
          label={label}
          onClick={e => e.stopPropagation()}
          control={
            <Checkbox
              name={name}
              checked={watchers[name]}
              onChange={({ target }) => onCheckOption && onCheckOption(name, target.checked)}
              color="primary"
            />
          }
        />
      ))}
    </FormGroup>
  );
};
